import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';
import { filter, first, map, timeout, throwError } from 'rxjs';
import { AuthStore } from './../stores/auth.store';

const NAVIGATE_TO_LOGIN = ['/', 'auth', 'login'];

export const authGuard: CanMatchFn = () => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return true;
  }

  const store = inject(AuthStore);

  return toObservable(store.status).pipe(
    filter((status) => status !== 'loading' && status !== null),
    first(), // Toma el primer valor que pase el filtro y completa
    timeout({
      each: 5000,
      with: () => {
        console.error(
          'Auth guard stuck: status did not change from "loading" after 5 seconds.'
        );
        // En caso de timeout, redirigimos al login
        router.navigate(NAVIGATE_TO_LOGIN);
        return throwError(() => new Error('Auth initialization timeout'));
      },
    }),
    map(() => {
      if (store.user()) {
        return true;
      }
      router.navigate(NAVIGATE_TO_LOGIN);
      return false;
    })
  );
};
